import React, { useEffect, useState, useRef } from 'react';

import Select from 'react-select';

import CheckBoxOption from './checkbox-option';
import CustomMenuList from './search-menu-list';
import NewValueContainer from './new-value-container';

function getSelectDropdown(
  hasBorder: boolean,
  placeholder: string = '',
  extraOptions: Array<{
    label: string,
    value: string,
  }> = [],
  label = '',
  sortOptions = false,
) {
  const SelectDropdown = ({
    items,
    refine,
  }) => {
    const options: Array<{
        label: string,
        value: string,
      }> = [...extraOptions];
    const selectedValue: any[] = [];
    let extraCss = '';
    extraCss += hasBorder ? '' : 'no-border';

    items.map((item) => {
      const itemObj = {
        value: item.value,
        label: item.label,
      };
      options.push(itemObj);
      if (item.isRefined) {
        selectedValue.push(itemObj);
      }
      return true;
    });

    // Set component length based on the placeholder
    const length = `${(9 * placeholder.length) + 60}px`;

    // Custom sub-component styles
    const selectStyles = {
      control: (styles) => {
        return {
          ...styles,
          width: length,
        };
      },
      menuList: (styles) => {
        return {
          ...styles,
          paddingTop: 0,
          paddingBottom: 0,
        };
      },
      option: (styles) => {
        return {
          ...styles,
          backgroundColor: 'white',
          color: 'inherit',
        };
      },
    };

    const containerRef = useRef<HTMLDivElement>(null);
    // Is the select box focused (and open?)
    const [isFocused, setIsFocused] = useState(false);
    // Contents of the select input search
    const [inputValue, setInputValue] = useState('');

    /**
     * Open or close the menu any time a click event is registered. Based
     * on the following conditions:
     *
     * Close the component and reset to empty search if
     * 1) The click is outside the component
     * 2) The menu (options dropdown) is not open
     * 3) The click is outside the menu
     *
     * Otherwise keep it open
     */
    const onDomClick = (e) => {
      if (!containerRef || !containerRef.current) {
        return;
      }

      const menu = containerRef.current.querySelector('.algolia-select__menu');

      if (
        !containerRef.current.contains(e.target)
        || !menu
        || !menu.contains(e.target)
      ) {
        setIsFocused(false);
        setInputValue('');
      } else {
        setIsFocused(true);
      }
    };

    useEffect(() => {
      document.addEventListener('mousedown', onDomClick);

      return () => {
        document.removeEventListener('mousedown', onDomClick);
      };
    }, []);

    return (
      <div ref={containerRef}>
        <Select
          aria-label={label || placeholder}
          className={`algolia-select ${extraCss}`}
          classNamePrefix="algolia-select"
          value={selectedValue}
          components={{
            MenuList: CustomMenuList,
            ValueContainer: NewValueContainer,
            Option: CheckBoxOption,
          }}
          onChange={(event) => {
            setIsFocused(false);
            if (event.value === 'all') {
              refine('');
              return;
            }
            refine(event.value);
          }}
          isSearchable={false} // Turns default search off. Use custom search in MenuList component
          options={sortOptions
            ? options.sort(
              (a, b) => {
                if (a.label < b.label) {
                  return -1;
                }
                if (a.label > b.label) {
                  return 1;
                }
                return 0;
              },
            ) : options}
          placeholder={placeholder}
          styles={selectStyles}
          name="color"
          onInputChange={(val) => setInputValue(val)}
          menuIsOpen={isFocused || undefined}
          isFocused={isFocused || undefined}
          inputValue={inputValue}
          onMenuInputFocus={() => setIsFocused(true)}
          setInputValue={setInputValue}
          setIsFocused={setIsFocused}
        />
      </div>
    );
  };
  return SelectDropdown;
}

export default getSelectDropdown;
